import { Component, OnInit, ViewEncapsulation, HostBinding } from '@angular/core';

@Component({
  selector: 'app-dmi-pages',
  templateUrl: './dmi-pages.component.html',
  styleUrls: ['./dmi-pages.component.scss','../../../assets/dmi-common.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DmiPagesComponent implements OnInit {

 	@HostBinding('class.dark-theme') useDarkTheme = false;
	@HostBinding('class.light-theme') useLightTheme = true;
  @HostBinding('class.page') classPage = true;
  constructor() { }

  ngOnInit(): void {
  }

}
